import React from "react";
import styled from "styled-components";

const Primary = styled.h3`
  color: red;
  text-align: center;
  max-width: 350px;

  display: flex;
  flex-flow: column nowrap;
`;

class emailError extends React.Component {
  constructor() {
    super();
    this.state = {
      //text: 'Error Please Try Again'
    };
  }

  render() {
    return <Primary>{this.props.text || "Error Please Try Again"}</Primary>;
  }
}

export default emailError;



// WEBPACK FOOTER //
// ./src/components/EmailError/index.jsx